// components
import { Button, Tooltip } from '@mui/material';
import ActionTooltipBody from './ActionTooltipBody';

// hooks
import { createPortal } from 'react-dom';
import { ActionTooltipProps } from './ActionTooltip.types';
import {
  StyledActionTooltipBackdrop,
  StyledActionTooltipContainerBox
} from './ActionTooltip.styles';

export default function ActionTooltip({
  children,
  open,
  title,
  actionButtons,
  handleClose
}: ActionTooltipProps) {
  return (
    <>
      {/* Backdrop */}
      {open &&
        createPortal(
          <StyledActionTooltipBackdrop
            draggable={false}
            onClick={handleClose}
          />,
          document.body
        )}

      {/* Tooltip */}
      <Tooltip
        arrow
        placement="top"
        open={open}
        title={
          <ActionTooltipBody title={title} onClose={handleClose}>
            <StyledActionTooltipContainerBox>
              {actionButtons.map(({ label, variant, onClick }) => (
                <Button
                  key={label}
                  variant={variant || 'outlined'}
                  size="small"
                  onClick={onClick}
                >
                  {label}
                </Button>
              ))}
            </StyledActionTooltipContainerBox>
          </ActionTooltipBody>
        }
      >
        {children}
      </Tooltip>
    </>
  );
}
